<template>
  <a-modal
    centered
    title="新增集团"
    v-model="visible"
    @cancel="visible = false"
    @ok="onSubmit"
    :maskClosable="false"
    :confirmLoading="loading"
    width="600px"
  >
    <div>
      <data-form
        ref="dataForm"
        labelSize="small"
        :content="content"
        :fixedLabelWidth="true"
        :labelCol="5"
        :wrapperCol="19"
        :colnum="1"
        :showButton="false"
      >
      </data-form>
    </div>
  </a-modal>
</template>
<script>
import { DataForm } from "@/components/dataForm";
export default {
  components: {
    DataForm
  },
  data() {
    return {
      visible: false,
      orderInfo: {},
      loading: false,
      content: [
        {
          label: "门店名称",
          name: "CompanyName",
          option: {
            rules: [
              { required: true, message: "请输入门店名称!" },
              {
                validator: (rule, value, callback) => {
                  if (value.length > 20) {
                    callback(new Error("名称长度最大为20位"));
                  } else {
                    callback();
                  }
                }
              }
            ]
          },
          props: {
            length: 20
          }
        },
        {
          label: "门店编号",
          name: "CompanyCode",
          option: {
            rules: [
              { required: true, message: "请输入门店编号!" },
              {
                validator: (rule, value, callback) => {
                  if (value.length < 4 || value.length > 20) {
                    callback(new Error("编号长度为4-20位"));
                  } else {
                    callback();
                  }
                }
              }
            ]
          }
        }
      ]
    };
  },
  created() {},
  methods: {
    onShow() {
      this.visible = true;
      this.loading = false;
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields();
      });
    },
    onCancel() {
      this.visible = false;
    },
    onSubmit() {
      this.$refs.dataForm.getData(true).then(values => {
        this.loading = true;
        this.$get("InitCompanyData", {
          ...values,
          GroupCode: values.CompanyCode,
          notToken: true
        })
          .then(() => {
            this.$emit("submit");
            this.visible = false;
            this.loading = false;
            this.$info({
              title: "新增集团成功",
              content: () => (
                <div>
                  可用新增的集团编号
                  <span style="color:#f00">【{values.CompanyCode}】</span>
                  直接登录
                </div>
              )
            });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
